import { useMemo } from 'react';
import { useApi } from './useApi';
import type { Parent } from '../types';

export function useParentApi() {
  const call = useApi();
  return useMemo(() => ({
    getMe: () => call<Parent>('/api/v1/parent/me'),
    updateMe: (patch: Partial<Pick<Parent, 'firstName'>> & {
      onboardedAt?: boolean;
      welcomeSeen?: boolean;
      emailDigestOptOut?: boolean;
      familyShareSeen?: boolean;
      seasonRecapBannerSeen?: boolean;
    }) =>
      call<Parent>('/api/v1/parent/me', { method: 'PATCH', body: patch }),
    /**
     * Horizon 1 / H1.1 — "On this day" lookup for the dashboard widget.
     * Returns null when no prior-year match exists for today's calendar day.
     */
    onThisDay: () =>
      call<null | {
        matchId: string;
        kidId: string;
        kidName: string;
        date: string;
        yearsAgo: number;
        summary: string;
      }>('/api/v1/on-this-day'),
  }), [call]);
}
